import React, { useEffect, useState } from 'react'
import CustomerTypeForm from '../../components/Forms/CustomerType/CustomerTypeForm'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'
import { useCustomerType } from '../../hooks/CompanyConfiguration/useCustomerType'
import { ROUTES } from '../../shared/constants'

export default function AddCustomerType({ customerType }) {
  const { addCustomerType, updateCustomerType, loading } = useCustomerType()
  const [customerTypeForm, setCustomerTypeForm] = useState({
    name: '',
    customerTypeCode: '',
  })
  //console.log('TAX : ', customerTypeForm)
  const handleAddCustomerType = () => {
    if (customerType) {
      updateCustomerType({
        customerTypeId: customerType._id,
        name: customerTypeForm.name,
        customerTypeCode: customerTypeForm.customerTypeCode,
      })
    } else {
      addCustomerType({
        name: customerTypeForm.name,
        customerTypeCode: customerTypeForm.customerTypeCode,
      })
    }
  }

  useEffect(() => {
    if (customerType) {
      setCustomerTypeForm({
        ...customerTypeForm,
        name: customerType.name,
        customerTypeCode: customerType.customerTypeCode,
      })
    }
  }, [customerType])

  const inputField = [
    { label: 'Customer Type Code', value: customerTypeForm.customerTypeCode, name: 'customerTypeCode' },
    { label: 'Name', value: customerTypeForm.name, name: 'name' },
  ]
  return (
    <Layout heading="Customer Type" heading2={customerType ? 'Edit' : 'Add'} url1={ROUTES.CUSTOMERTYPE} none>
      <HeaderTabLayout
        heading={`${customerType ? 'Edit' : 'Add'} Customer Type`}
        content={<CustomAddForm state={customerTypeForm} setState={setCustomerTypeForm} data={inputField} />}
        addContent={handleAddCustomerType}
        redirect={ROUTES.CUSTOMERTYPE}
        loading={loading}
        state={customerTypeForm} setState={setCustomerTypeForm}
      />
    </Layout>
  )
}
